import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['initialPlate', 'feedbackPlate'];

  get disagreeFeedback() {
    return this.element.querySelector('#disagree-feedback');
  }

  get agreeFeedback() {
    return this.element.querySelector('#agree-feedback');
  }

  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  get isAgreeCorrect() {
    return this.agreeFeedback.classList.contains('correct');
  }

  get isDisagreeCorrect() {
    return this.disagreeFeedback.classList.contains('correct');
  }

  approve() {
    this.disagreeFeedback.classList.add('display-none');
    this.agreeFeedback.classList.remove('display-none');
    this.showFeedbackPlate();

    if (this.isAgreeCorrect) {
      this.enableNextNavigation();
    }
  }

  reject() {
    this.agreeFeedback.classList.add('display-none');
    this.disagreeFeedback.classList.remove('display-none');
    this.showFeedbackPlate();

    if (this.isDisagreeCorrect) {
      this.enableNextNavigation();
    }
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }

  showFeedbackPlate() {
    if (this.hasFeedbackPlateTarget) {
      this.initialPlateTarget.classList.add('display-none');
      this.feedbackPlateTarget.classList.remove('display-none');
    }
  }
}
